import * as React from 'react';
import './ProfessionalDisciplinesPage.scss';

import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { routerActions } from 'react-router-redux';
import { Location, History } from "history";
import ReactTable, { RowInfo } from 'react-table';
import * as ProfessionalDisciplineActions from '../../../actions/professionalDisciplines';
import * as Dtos from '../../../dtos/Tmd.dtos';
import { ITmdState, IFormFilter } from "../../../reducers/index";
import { RequestState } from "../../../enumerations/RequestState";
import { Link } from "../../../components/routing/index";
import { FontAwesomeIcon, FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";
import { DEFAULT_PAGE_SIZE, PAGE_SIZE_OPTIONS } from "../../../constants/reactTableConstants";
import * as AuthenticationHelper from '../../../helpers/authentication';
import { FormFilterInput } from '../../../components/form';
import { LookupsLayout } from '../../index';

interface IProfessionalDisciplinesPageProps {

    location: Location;
    history: History;

    // From state
    formFilter: IFormFilter;
    professionalDiscipline: Dtos.ProfessionalDiscipline[];
    loadingProfessionalDisciplines: boolean;
    loadProfessionalDisciplinesSuccess: boolean;
    loadProfessionalDisciplinesFailure: boolean;

    user: Dtos.User;
    permissions?: Dtos.PersonnelTmdPermissions[];
    formRoles?: Dtos.RoleType[];
}

interface IProfessionalDisciplinesPageActions {
    clearProfessionalDisciplines: ProfessionalDisciplineActions.IProfessionalDisciplineClearActionCreator;
    loadProfessionalDisciplines: ProfessionalDisciplineActions.IProfessionalDisciplineLoadActionCreator;

    navigate: typeof routerActions.push;
    navigateReplace: typeof routerActions.replace;

    filter: ProfessionalDisciplineActions.IProfessionalDisciplineFilterActionCreator;
}

type ProfessionalDisciplinesPageProps = IProfessionalDisciplinesPageProps & IProfessionalDisciplinesPageActions;

class ProfessionalDisciplinesPage extends React.PureComponent<ProfessionalDisciplinesPageProps, any> {

    constructor(props: ProfessionalDisciplinesPageProps) {
        super(props);

        this.clearProfessionalDisciplines = this.clearProfessionalDisciplines.bind(this);
    }

    componentDidMount() {
        const {
            loadProfessionalDisciplines
        } = this.props;

        loadProfessionalDisciplines();
    }

    componentWillReceiveProps(nextProps: ProfessionalDisciplinesPageProps) {
    }

    componentDidUpdate(prevProps: ProfessionalDisciplinesPageProps, prevState) {
        const {
            navigateReplace
        } = this.props
    }

    componentWillUpdate(nextProps: ProfessionalDisciplinesPageProps) {
    }

    componentWillUnmount() {
        this.clearProfessionalDisciplines();
    }

    clearProfessionalDisciplines() {
        this.props.clearProfessionalDisciplines();
    }

    showProfessionalDisciplines(): boolean {
        const {
            loadingProfessionalDisciplines,
            loadProfessionalDisciplinesSuccess
        } = this.props

        if (!loadingProfessionalDisciplines && loadProfessionalDisciplinesSuccess) {
            return true;
        }

        return false;
    }

    render() {
        const {
            loadingProfessionalDisciplines
        } = this.props;

        return <LookupsLayout loading={loadingProfessionalDisciplines} permission={Dtos.Permission.ProfessionalDisciplinesView}>
            {this.renderContent()}
        </LookupsLayout>;
    }

    renderContent() {
        const {
            permissions
        } = this.props;

        return <div>
            <div className="row">
                <div className={"col-6 mb-2"}>
                    <h2>Professional Disciplines</h2>
                </div>
                <div className="col-6" style={{ textAlign: 'right' }}>
                    <FormFilterInput formFilter={this.props.formFilter} onFilter={e => this.props.filter(e) } />
                    
                    {AuthenticationHelper.hasPermission(permissions, Dtos.Permission.ProfessionalDisciplinesCreate) && (
                        <Link className={"btn btn-primary"} url={"/settings/general/professionaldisciplines/create"}>Create</Link>
                    )}
                </div>
            </div>
            {
                !this.showProfessionalDisciplines() ?
                    "Loading Professional Disciplines" :
                    null
            }
            {
                this.showProfessionalDisciplines() ?
                    <div className="patient-tables mt-2">
                        {
                            this.createTable()
                        }
                    </div> :
                    null
            }
        </div>
    }

    createTable() {

        const {
            professionalDiscipline
        } = this.props

        if (!professionalDiscipline || professionalDiscipline.length == 0) {
            return <div className="alert alert-info d-flex">
                <div className="mr-2">
                    <FontAwesomeIcon icon={FontAwesomeIcons.Solid.INFO_SQUARE} fixedWidth />
                </div>
                <span>There are currently no professional disciplines to view.</span>
            </div>
        }

        const showPagination = professionalDiscipline.length > DEFAULT_PAGE_SIZE;

        return <div className="table-wrapper mb-3">
            <ReactTable
                data={professionalDiscipline}
                pageSizeOptions={PAGE_SIZE_OPTIONS}
                defaultPageSize={showPagination ? DEFAULT_PAGE_SIZE : professionalDiscipline.length}
                pageSize={showPagination ? undefined : professionalDiscipline.length}
                showPagination={showPagination}
                className="-striped -highlight -clickable mb-3"
                noDataText="There are currently no professionalDiscipline to display"
                resizable={false}
                getTdProps={(state, rowInfo: RowInfo, column, instance) => {
                    return {
                        onClick: (e, handleOriginal) => {

                            const url: string = "/settings/general/professionaldisciplines/" + rowInfo.original.id;
                            this.props.navigate(url);

                            if (handleOriginal) {
                                handleOriginal()
                            }

                        },
                        style: {
                            color: (rowInfo && rowInfo.original && rowInfo.original.active) ? '#212529' : '#9e9e9e'
                        }
                    }
                }}
                columns={[
                    {
                        id: "id",
                        Header: ' ',
                        accessor: "id",
                        className: "d-flex align-items-center justify-content-center",
                        maxWidth: 50,
                        Cell: (props) => <FontAwesomeIcon icon={FontAwesomeIcons.Light.LOOKUP} fixedWidth />
                    },
                    {
                        id: "value",
                        Header: 'Name',
                        accessor: 'value',
                        className: "d-flex align-items-left justify-content-left",
                        headerClassName: "text-left"
                    }
                ]}
            />
        </div>

    }

}

const mapStateToProps = (state: ITmdState, ownProps: ProfessionalDisciplinesPageProps): IProfessionalDisciplinesPageProps => {

    let permissions = state.user.userSummary ? state.user.userSummary.permissions : [];

    return {

        history: ownProps.history,
        location: state.routing.location,

        formFilter: state.professionalDisciplines.formFilter,
        professionalDiscipline: state.professionalDisciplines.formFilteredData, 

        loadingProfessionalDisciplines: state.professionalDisciplines.loadState && state.professionalDisciplines.loadState.status == RequestState.Pending,
        loadProfessionalDisciplinesSuccess: state.professionalDisciplines.loadState && state.professionalDisciplines.loadState.status == RequestState.Success,
        loadProfessionalDisciplinesFailure: state.professionalDisciplines.loadState && state.professionalDisciplines.loadState.status == RequestState.Failure,

        user: state.user.data,
        permissions: permissions,
        formRoles: state.user.formRoles
    };
};

const mapDispatchToProps = (dispatch): IProfessionalDisciplinesPageActions => {
    return {
        navigate: bindActionCreators(routerActions.push, dispatch),
        navigateReplace: bindActionCreators(routerActions.replace, dispatch),

        loadProfessionalDisciplines: bindActionCreators(ProfessionalDisciplineActions.LoadProfessionalDiscipline, dispatch),
        clearProfessionalDisciplines: bindActionCreators(ProfessionalDisciplineActions.Clear, dispatch),

        filter: bindActionCreators(ProfessionalDisciplineActions.Filter, dispatch),
    };
};

export default
    connect(mapStateToProps, mapDispatchToProps)(ProfessionalDisciplinesPage);
